var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../../converters/DateConverter";
export class Period {
  constructor(_data) {
    /**
     */
    __publicField(this, "DueDate");
    /**
     */
    __publicField(this, "End");
    /**
     */
    __publicField(this, "Id");
    /**
     */
    __publicField(this, "Start");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Period
     */
    __publicField(this, "$type", "V1.SubmissionPeriods.UK.Period");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.DueDate = DateConverter.from(_data["DueDate"]);
      this.End = DateConverter.from(_data["End"]);
      this.Id = _data["Id"];
      this.Start = DateConverter.from(_data["Start"]);
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["DueDate"] = DateConverter.toUtcDateString(this.DueDate);
    _data["End"] = DateConverter.toUtcDateString(this.End);
    _data["Id"] = this.Id;
    _data["Start"] = DateConverter.toUtcDateString(this.Start);
    return _data;
  }
}
